import { render, staticRenderFns } from "./IncProductPriceLabel.vue?vue&type=template&id=a7daf58e&scoped=true"
import script from "./IncProductPriceLabel.vue?vue&type=script&lang=js"
export * from "./IncProductPriceLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7daf58e",
  null
  
)

export default component.exports